function import_all( r ) {
	r.keys().forEach( r );
}

import_all( require.context( './tutor-filters', true, /\.js$/ ) );